import React, { Component } from 'react';
import {
  View,
  Text,
  TouchableHighlight,
  Dimensions,
  Image,
  Alert,
  ScrollView,
  ActivityIndicator,
  Platform, 
  Clipboard,
} from 'react-native';
import {StyleContext} from '../styleC';
import strings from '../strings';
import info from '../info';
import firebase from './firebase';
import MavButton from './mavButton';
import MavTextInput from './mavTextInput';
import MavAlert from './mavAlert';
import Wait3DSecure from './wait3DSecure';
const timer = require('react-native-timer');
import moneyList from '../moneyList';
import MavNavigationMinimize from './mavNavigationMinimize';
import AddCreditCard from './addCreditCard';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue} from "firebase/database";

export default class payment extends Component {
  constructor(props) {
    super(props);
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 


    var requireList=[];
    var i;
    for (i=0;i<info.paymentList.length;i++){
      var r;
      if(info.paymentList[i]=="paymentCash") r=require('../assets/paymentCash.png')
        else if (info.paymentList[i]=="paymentCard") r=require('../assets/paymentCard.png')
        else if (info.paymentList[i]=="paymentTransfer") r=require('../assets/paymentTransfer.png')
        else if (info.paymentList[i]=="paymentPaypal") r=require('../assets/paymentPaypal.png')
        else r=require('../assets/paymentBankCheck.png')

          requireList.push(r)

      
    }
    var exempleDateCard=new Date();
    exempleDateCard.setFullYear(exempleDateCard.getUTCFullYear()+2)
    exempleDateCard=exempleDateCard.getUTCFullYear().toString()[2]+exempleDateCard.getUTCFullYear().toString()[3]
    exempleDateCard="07/"+exempleDateCard;


    this.state={
      waiting:true,
      mode:(info.paymentCardApp!==true)?"classic":"mainCard",
      extraEUMode:(params!=undefined && params.extraEUMode==true)?true:false,
      requireList:requireList,
      exempleDateCard:exempleDateCard,
      newCard:{number:"",expiration:"",cvv:""},
      cardList:[],
      params:params, 
      buyRechargePrice:"",
      useRechargeCode:"",
      balance:0,
      waiting3DSecure:false,
      balanceOther:[],
    }
    

  }

  findMoney(value){
    if(value==undefined) value="eu";
    var final="";
    var i; 
    for(i=0;i<moneyList.length;i++){
      if(final==""){
        if(moneyList[i].id==value) final=moneyList[i];
      }
    }
    return final
  }




removeCard(cardId){
  if(this.state.waiting===false){
    this.setState({waiting:true})
    console.log(cardId)

    getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={
                  userID:getAuth(firebase).currentUser.uid,
                  bundleIdentifer:info.bundleIdentifer,
                  cardId:cardId,
                  token:token,
                  bundleAdress:info.firebaseProjectID,
                  version:info.appliVersion,
              }

              fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/deleteStripeCard", {
                    body: JSON.stringify(body),
                    method: "POST"}).then((response) => response.text())
                  .then((responseJson) => {
                if(responseJson==="ok"){this.setState({waiting:false}); this.getUserCards()}
                      else{console.log(responseJson); this.alert.onAlert({title:strings.errorDefault});this.setState({waiting:false})}


                     }).catch((err) => { console.log("error removeCard"); console.log(err); timer.setTimeout("removeCard", () => { this.removeCard();  }, 2000);   })
      })


    }

}

getUserBalance(){
  getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={
                  userID:getAuth(firebase).currentUser.uid,
                  bundleIdentifer:info.bundleIdentifer,
                  token:token,
                  bundleAdress:info.firebaseProjectID,
                  version:info.appliVersion
              }
              fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getUserBalance", {
                      body: JSON.stringify(body),
                        method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                            console.log("reponse de getUserBalance")
                            
                            var res=responseJson
                            this.setState({balance:res.balance,waiting:false,  })
                            if(res.accountBalanceOther!=undefined){
                              var arrBO=Object.keys(res.accountBalanceOther)
                              var tot=[];
                              var mo;
                              var i;
                              for(i=0;i<arrBO.length;i++){

                                var ab=""+arrBO[i];
                                mo=this.findMoney(arrBO[i]);
                    

                                tot.push({amount: res.accountBalanceOther[ab], symbole:mo.symbole,position:mo.position  })
                              }
                              this.setState({balanceOther:tot})
                            }
                            
                          
                        }).catch((err) => { console.log("error getUserBalance"); console.log(err); timer.setTimeout("getUserBalance", () => { this.getUserBalance();  }, 2000);   })
 

        })
}

getPromo(){
  var bodyPromo={
        uuid:getAuth(firebase).currentUser.uid,
        version:info.appliVersion
      }


      fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/testPermanentPromoCodeAndDeferredPayment", {
        body: JSON.stringify(bodyPromo),
        method: "POST"}).then((response) => response.json()).then((responseJson) => {
          var res=responseJson
          if(res.deferredPayment!=undefined && res.deferredPayment==true) this.setState({mode:"deferredPayment",})
        }).catch((err) => { console.log("error getPromo"); console.log(err); timer.setTimeout("getPromo", () => { this.getPromo();  }, 2000);   })
}

componentDidMount() {
  if(getAuth(firebase).currentUser!=undefined){
  if(info.paymentCardApp===true && (this.state.params==undefined || this.state.params.addCredit!=true )) this.getUserCards();
  this.getUserBalance()
  this.getPromo();

      

                }
}


getUserCards(){

  get(child(ref(getDatabase(firebase)), '/users/'+getAuth(firebase).currentUser.uid+"/email")).then(snapshot => { 
      var email=snapshot.val();
      getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={
                  userID:getAuth(firebase).currentUser.uid,
                  bundleIdentifer:info.bundleIdentifer,
                  token:token,
                  bundleAdress:info.firebaseProjectID,
                  email:email,
                  version:info.appliVersion,
              }

        fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getUserCards", {
          body: JSON.stringify(body),
            method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                    var res=responseJson
                    var i;
                    for(i=0;i<res.length;i++){
                      
                      res[i].text="*"+res[i].last4;
                      res[i].icon=(res[i].brand.toLowerCase()==="visa")?require("../assets/visa.png"):((res[i].brand.toLowerCase()==="mastercard")?require("../assets/mastercard.png"):((res[i].brand.toLowerCase()==="amex")?require("../assets/amex.png"):require("../assets/paymentCard.png")))
                      res[i].image=(res[i].brand.toLowerCase()==="visa")?require("../assets/visa.png"):((res[i].brand.toLowerCase()==="mastercard")?require("../assets/mastercard.png"):((res[i].brand.toLowerCase()==="amex")?require("../assets/amex.png"):require("../assets/paymentCard.png")))
                      if(i===0) this.setState({cardSelected:res[0]})
                    }
                    if(this.state.params!=undefined && (this.state.params.addCredit==true)){
                      this.state.params.useCard(res[i-1])
                      var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;  params.goBack();
                    }
                    this.setState({cardList:res})
              
              
            }).catch((err) => { console.log("error getUserCards"); console.log(err); timer.setTimeout("getUserCards", () => { this.getUserCards();  }, 2000);   })
 

    });

    })
}


  viewCard(){
      var selected=-1;
      var i;
      for(i=0;i<this.state.cardList.length;i++){
          if(this.state.cardList[i].id==this.state.cardSelected.id) selected=i;
      }
      this.alert.onAlert({title:strings.payment, items:this.state.cardList ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {
        if(this.state.cardList[id].id==="addCard") this.setState({viewAddCard:true})
        else { this.setState({cardSelected:this.state.cardList[id]}) }
       
      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

  }

buyRecharge(){
  var value=parseInt(this.state.buyRechargePrice)
  if(value.toString()==="NaN" || value<0) this.alert.onAlert({title:strings.priceBillError}) 
  else {
    this.setState({waiting:true});

    getAuth(firebase).currentUser.getIdToken().then(token => {
    var body={
      userID:getAuth(firebase).currentUser.uid,
      bundleIdentifer:info.bundleIdentifer,
      price:value,
      source:this.state.cardSelected.id,
      token:token,
      bundleAdress:info.firebaseProjectID,
      version:info.appliVersion
    }

    fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/buyRecharge", {
                body: JSON.stringify(body),
                method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                
                            var rep=responseJson
                            console.log(rep)
                  if(rep.payment==="ok"){
                    console.log("le paiement est ok")
                    this.setState({waiting:false,mode:"mainCard" })
                     this.alert.onAlert({
                          title:strings.yourRechargeCode,
                          subTitle:strings.rechargeNowOrGive,
                          code:rep.recharge.rechargeID,
                          buttons:[{text: strings.copy,onPress: () => {this.copyToClipboard(rep.recharge.rechargeID)}},{text: strings.close, onPress: () => {}}]

                        });


                    
                  }
                  else if(rep.payment=="requiresAction"){
                      this.setState({waiting:false,waiting3DSecure:true,waiting:false,mode:"mainCard" })

                  } 
                  else {this.alert.onAlert({title:strings.errorDefault}); this.setState({waiting:false})} 
                }).catch((err) => { console.log("error buyRecharge"); console.log(err); timer.setTimeout("buyRecharge", () => { this.buyRecharge();  }, 2000);   })


              })

 

  }

}


useRecharge(){
  if(this.state.useRechargeCode==="") this.alert.onAlert({title:strings.noCode}) 
  else {
    this.setState({waiting:true});

    getAuth(firebase).currentUser.getIdToken().then(token => {
    var body={
      userID:getAuth(firebase).currentUser.uid,
      bundleIdentifer:info.bundleIdentifer,
      token:token,
      rechargeID:this.state.useRechargeCode,
      bundleAdress:info.firebaseProjectID,
    }

    fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/useRecharge", {
                body: JSON.stringify(body),
                method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                
                            var rep=responseJson
                  if(rep.add===true){
                        this.setState({waiting:false,mode:"mainCard",balance:this.state.balance+rep.amount,useRechargeCode:"" })
                        this.alert.onAlert({
                          title:strings.thanks,
                          subTitle:strings.yourAccountHasBeenCreditate+" "+rep.amount+"€",
                        });

                  }
                  else {
                    if(rep.error==="alreadyUse") this.alert.onAlert({title:strings.codeAlreadyUse});
                    else this.alert.onAlert({title:strings.codeNotFound,subTitle:strings.codeNotFoundExplication});
                    this.setState({waiting:false})
                  } 
                }).catch((err) => { console.log("error useRecharge"); console.log(err); timer.setTimeout("useRecharge", () => { this.useRecharge();  }, 2000);   })


              })

 

  }

}

copyToClipboard(code){
  Clipboard.setString(code);

}



render() {
    return (
      <StyleContext.Consumer>{style => 
        <View style={{flex:1}}>
        {(Platform.OS=="web") && <MavNavigationMinimize clickLeft={() => { this.state.params.goBack();  }} left={strings.return} title={ strings.payment } />}


        <ScrollView style={{flex:1,backgroundColor:style.backgroundColor}}>
          
          {false && ((this.state.waiting3DSecure==true && this.state.params!=undefined && (this.state.params.waiting3DSecureStatus!="validate" || this.state.params.waiting3DSecureStatus!="fail")) || this.state.params.waiting3DSecure==true) && <Wait3DSecure status={this.state.params.waiting3DSecureStatus} />}


          {(this.state.waiting==true && this.state.mode==="mainCard") && <ActivityIndicator style={{marginTop:30}} size="large" color={style.color1} />}


          {(this.state.mode==="classic") && <View>
              <Text style={{textAlign: 'center', color: style.textInputColor,fontSize: style.textInputFontSize, marginTop:Dimensions.get('window').height * 0.07 ,marginLeft:"10%", marginRight:"10%" }}>{strings.paiementExplication}</Text>

              { info.paymentList.map((rowData,i)=>( <View style={{marginTop:Dimensions.get('window').height * 0.07,justifyContent: 'center',alignItems: 'center',}}>
                        <Image source={this.state.requireList[i]} style={{height:Dimensions.get('window').height*0.07,width:Dimensions.get('window').height*0.07,resizeMode:"contain"}}/>
                        <Text style={{fontSize: 17,color: style.textInputColor, }}>{strings[rowData]}</Text>
                    </View>
                  ))}

              <MavButton text={strings.ImUnderstand.toUpperCase()} style={{marginTop:50,marginBottom:15}} onPress={()=>{var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;  params.goBack(); }}/>

          </View>}

          {(this.state.mode==="deferredPayment") && <View>

              <Text style={{textAlign: 'center', fontSize: style.textInputFontSize, marginTop:20 ,marginLeft:"10%",marginRight:"10%",color: style.textInputColor,}}>{strings.deferredPaymentEnabled}</Text>

              <View style={{alignItems:"center",justifyContent:"center", marginTop:50,marginBottom:15}}> 
                  <MavButton text={strings.ImUnderstand.toUpperCase()} onlyButton={true} onPress={()=>{var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;  params.goBack(); }}/>
              </View>

          </View>}


          {(this.state.mode==="mainCard" && this.state.waiting!=true) && <View>

              <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",marginBottom:5}}>{strings.yourCredit}</Text>
              {(this.state.balance>0 || this.state.balanceOther.length==0) && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",}}>{(this.state.balance===0)?strings.yourHaveNotCredit:strings.creditYouHave+" : "+this.state.balance+"€"}</Text>}

              
              {this.state.balanceOther.map(list => (
                <View>
                  {list.amount>0 && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center"}}>{strings.creditYouHave+" : "+((list.position=="left")?(list.symbole+" "):"")+list.amount+((list.position=="right")?(list.symbole):"")}</Text>}
                </View>
                ))}
              
             {this.state.extraEUMode==false && <View style={{flexDirection: 'row',marginTop:10,marginBottom:15,alignItems: 'center',justifyContent: 'center',}}>
                {this.state.cardList.length>0 && <MavButton text={strings.buyRecharge.toUpperCase()} onlyButton={true} style={{marginRight:15}} onPress={()=>{this.setState({mode:"buyRecharge"})}}/>}
                <MavButton text={strings.useRecharge.toUpperCase()} onlyButton={true} strokeMode={true}  style={{}} onPress={()=>{this.setState({mode:"useRecharge"})}}/>
              </View>}

              <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",marginBottom:(this.state.cardList.length===0)?5:10}}>{strings.yourCards}</Text>
              {(this.state.cardList.length===0) && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",marginBottom:10}}>{strings.youHaveNotCard}</Text>}
              {this.state.cardList.map(card => (<MavTextInput style={{marginTop:5}} textInputFlex={0.2} textExplication={card.text} textExplicationMini={strings.cardExpiration+" : "+((card.exp_month<10)?"0":"")+card.exp_month+"/"+card.exp_year} enableRemove={true} editable={false} onRemove={()=>{this.removeCard(card.id)}} iconClassic={card.icon} disableText={true} /> ))}

              

              <View style={{marginTop:20}}> 
                <AddCreditCard newCardAdded={() => { this.getUserCards() }} />
              </View>
              











          </View>}



          {(this.state.mode==="buyRecharge") && <View>
            <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",marginBottom:10}}>{strings.buyRecharge}</Text>
            <Text style={{marginLeft:Dimensions.get('window').width*0.1,marginRight:Dimensions.get('window').width*0.1,color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",marginBottom:10}}>{strings.whyBuyRecharge}</Text>

            <MavTextInput style={{marginTop:5}} textInputFlex={1.5} editable={!this.state.waiting} text={this.state.buyRechargePrice} textExplication={strings.montant} placeholder={"100€"} keyboardType={"numeric"} onChangeText={text => {
                     
                     this.setState({buyRechargePrice:text.toString().replace("€",'')})
                     timer.setTimeout("timer", () => {
                      var test=this.state.buyRechargePrice.indexOf("€");
                        if(test==-1 && this.state.buyRechargePrice!="") {
                          this.setState({buyRechargePrice:this.state.buyRechargePrice+"€"})
                        }
                     }, 1000);
                    }}/>
            <TouchableHighlight underlayColor={'rgba(255,255,255,0)'} onPress={() => {this.viewCard()}} > 
              <MavTextInput style={{marginTop:5}} textInputFlex={1.5} iconText={this.state.cardSelected.icon} editable={false}  text={"*"+this.state.cardSelected.last4} textExplication={strings.payment}  />
            </TouchableHighlight>

          

            {this.state.waiting!==true &&  <View style={{alignItems:"center",justifyContent:"center", marginTop:30,marginBottom:15}}> 
                <MavButton text={strings.validate.toUpperCase()} onlyButton={true} onPress={()=>{this.buyRecharge()}}/>
            </View>}
            {this.state.waiting!==true && <View style={{alignItems:"center",justifyContent:"center", marginBottom:15}}> 
                <MavButton text={strings.cancel.toUpperCase()} onlyButton={true} strokeMode={true} onPress={()=>{this.setState({mode:"mainCard"})}}/>
            </View>}

            {this.state.waiting==true && <ActivityIndicator style={{marginTop:30}} size="large" color={style.color1} />}

          </View>}


          {(this.state.mode==="useRecharge") && <View>
            <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",marginBottom:10}}>{strings.useRecharge}</Text>
            <Text style={{marginLeft:Dimensions.get('window').width*0.1,marginRight:Dimensions.get('window').width*0.1,color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",marginBottom:10}}>{strings.howUseCode}</Text>

            <MavTextInput style={{marginTop:5}} textInputFlex={1.5} editable={!this.state.waiting} text={this.state.useRechargeCode} textExplication={strings.code} placeholder={"1234abcd54"} onChangeText={text => {this.setState({useRechargeCode:text})}}/>


            

            {this.state.waiting!==true && <View style={{alignItems:"center",justifyContent:"center", marginTop:30, marginBottom:15}}>
                <MavButton text={strings.validate.toUpperCase()} onlyButton={true}onPress={()=>{this.useRecharge()}}/>
            </View>}
            {this.state.waiting!==true && <View style={{alignItems:"center",justifyContent:"center", marginBottom:15}}>
                <MavButton text={strings.cancel.toUpperCase()} onlyButton={true} strokeMode={true} onPress={()=>{this.setState({mode:"mainCard"})}}/>
            </View>}
            {this.state.waiting==true && <ActivityIndicator style={{marginTop:30}} size="large" color={style.color1} />}
          </View>}




          


         




          <MavAlert ref={alert => {this.alert = alert;}}/>

          
        </ScrollView>

        </View>
        }</StyleContext.Consumer>

    );
  }
}




